export default __webpack_public_path__ + "static/6-min-42832f446bc7fb638277bbedfb78ce79.png";